import {Repository, createRepository} from '@/repositories/Base/Repository'

class ProtocolSettingRepository extends Repository {
    endpoint = 'vns/protocol_settings'

    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}/table`, {params})
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }

    post(params) {
        return this.$axios.post(`${this.endpoint}/post`, params)
    }

    put(id, params) {
        return this.$axios.post(`${this.endpoint}/post`, {...params, id: id})
    }
}

export default new ProtocolSettingRepository()

export const create = createRepository(ProtocolSettingRepository)
